import {getData, LOGIN} from "../../storage";
import {isEmpty} from "../../utility";
import constants from "../../constants";
import * as _ from "lodash";
import {get as _get} from "lodash";

const filters = {
    content: {
        title: "Content type",
        dropDown: {
            "All": "All",
            "Live": "Live",
            "Available": "Available",
            "Video": "Video",
            "Picture": "Picture",
        }
    },
    price: {
        title: "Pricing type",
        dropDown: {
            "All": "All",
            "Free": "Free",
            "Premium": "Premium",
            "Subscribed": "Subscribed",
            "Exclusive": "Exclusive",
        }
    },
    sort: {
        title: "Sort by",
        dropDown: {
            "New": "New",
            "Following": "Following",
            "Popular": "Popular",
            "Views": "Views",
        }
    }
}

const checkLoggedIn = (callback) => {
    getData(LOGIN)
        .then((data) => {
            if (!isEmpty(data)) {
                callback(true, data)
            } else {
                callback(false, null)
            }
        })
}

const showLogin = (props) => {
    props.history.push(
        {
            pathname: '/login',
            state: {
                basePath: props.history.location.pathname,
            }
        }
    );
};

const pageName = () => {
    const pathname = window.location.pathname;
    if(pathname.indexOf("/dashboard") >= 0){
        return constants.HOME;
    }else if(pathname.indexOf("/user/profile") >= 0){
        return constants.VIEWER_PROFILE;
    }else if(pathname.indexOf("/profile") >= 0){
        return constants.BROADCASTER_PROFILE;
    }

    return constants.HOME;
}

const getModifiedFilterValue = (stateKeyValue,value)=>{
    let modifiedValue = value;
    if (value.toLowerCase() !== "all") {
        let _tempArray = stateKeyValue.split(",");
        //remove all from array
        _.remove(_tempArray, function (n) {
            return n.toLowerCase() === "all";
        });
        //check if we are again pushing same value
        const index = _.findIndex(_tempArray, function (v) {
            return v === value.toLowerCase()
        });
        if (index >= 0) {
            //if we are pushing same value then remove it i.e. act as a toggle
            _.remove(_tempArray, function (n) {
                return n.toLowerCase() ===  value.toLowerCase();
            });

            //if the filter array is empty default it to all
            if(_tempArray.length === 0){
                _tempArray = ["all"];
            }
        } else {
            //user selected all
            _tempArray.push(value.toLowerCase());
        }
        modifiedValue = _.join(_tempArray, ',');
    }

    return modifiedValue;
}

const isVideo = (content) => {
    let loadVideo = true;
    if (content.hasOwnProperty("total_videos")) {
        if (content.hasOwnProperty("total_pictures") && content.total_pictures > 0) {
            loadVideo = false
        }
    }

    return loadVideo;
}

const ageRestrictionForContent = (nextProps, props, $key) => {
    const errorPayload = nextProps[$key].hasOwnProperty("payload") &&
        nextProps[$key].payload.hasOwnProperty("response") &&
        nextProps[$key].payload.response.hasOwnProperty("error") &&
        nextProps[$key].payload.response.error;

    if (errorPayload.hasOwnProperty("error_code")) {
        let error_code = errorPayload.error_code;
        switch (error_code) {
            case "1000":
                props.history.push(
                    {
                        pathname: '/login',
                        state: {
                            basePath: props.history.location.pathname,
                            search: _get(props, 'history.location.search', '')
                        }
                    }
                );
                break;
            case "1001":
                props.history.push(
                    {
                        pathname: '/broadcaster/register',
                        state: {
                            basePath: props.history.location.pathname,
                            search: _get(props, 'history.location.search', '')
                        }
                    }
                );
                break;
            default:
                props.history.push(
                    {
                        pathname: '/dashboard',
                        state: {
                            basePath: props.history.location.pathname,
                            search: _get(props, 'history.location.search', '')
                        }
                    }
                );
        }
    }
}

export default {
    filters,
    checkLoggedIn,
    showLogin,
    pageName,
    getModifiedFilterValue,
    isVideo,
    ageRestrictionForContent
}